<template>
  <div>
    <y-shelf title="发票管理">
      <div slot="content">
        <div class="deposit-main">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="发票信息" name="first">
              <el-table :data="orderDataList" style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column type="selection" align="center" />
                <el-table-column prop="servOrderNo" label="服务单号" width="220" align="center">
                </el-table-column>
                <el-table-column label="服务单类型" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    <serv-tag :code="scope.row.servCataId" />
                  </template>
                </el-table-column>
                <el-table-column prop="orderAmount" label="价格" align="center">
                </el-table-column>
                <el-table-column prop="payTime" label="支付时间" align="center">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <!--              <el-tab-pane label="寄送地址" name="second">
               <div class="tipnull" v-if="tableData.length==0">
                  <i class="el-icon-warning-outline"></i>
                  暂无地址，请先
                  <el-link @click="dialogVisible = true" style="font-size: 20px;" type="primary">添加地址</el-link>
                </div>
                <el-table
                  :data="tableData"
                  style="width: 100%"
                  v-if="tableData.length>0">
                  <el-table-column
                    prop="name"
                    label="收件人姓名"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="mobile"
                    label="电话号码"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="address"
                    label="地址">
                  </el-table-column>
                  <el-table-column
                    prop="postcode"
                    label="邮编"
                    width="140">
                  </el-table-column>
                  <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        @click="handleEdit(scope.$index, scope.row)" icon="el-icon-edit">编辑</el-button>
                      <el-button
                        size="mini"
                        type="danger"
                        @click="handleDelete(scope.$index, scope.row)" icon="el-icon-delete">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="margin-top: 10px;" v-if="tableData.length>0">
                  <el-link @click="dialogVisible = true" type="primary">+新增地址</el-link>
                </div>
              </el-tab-pane> -->
            <el-tab-pane label="电子邮箱" name="third">
              <div class="tipnull" v-if="emailData.length == 0">
                <i class="el-icon-warning-outline"></i>
                暂无数据
                <el-link @click="emaildialogVisible = true" style="font-size: 20px;" type="primary">添加邮箱</el-link>
              </div>
              <el-table :data="emailData" style="width: 100%" v-if="emailData.length > 0">
                <el-table-column prop="email" label="邮箱" width="150">
                </el-table-column>
                <el-table-column label="操作" width="200">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
                      icon="el-icon-edit">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)"
                      icon="el-icon-delete">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div style="margin-top: 10px;" v-if="emailData.length > 0">
                <el-link @click="emaildialogVisible = true" type="primary">+新增邮箱</el-link>
              </div>
            </el-tab-pane>
          </el-tabs>
          <div class="select-time">
            <el-date-picker v-model="queryParams.dateTime" type="month" size="small" style="width: 80%;"
              value-format="yyyy-MM" placeholder="选择日期时间">
            </el-date-picker>
          </div>
          <y-button text="搜索" classStyle="main-btn ml" @btnClick="querySearch"
            style="position: absolute;top: 0px;right: 0;"></y-button>
          <y-button :text="selectIds.length > 0 ? '下一步' : '请选择'" classStyle="main-btn" @btnClick="handleInvoiceIssuance"
            style="float: right;margin: 10px 0px 0 0;"></y-button>
          <div class="pagination-wrap" v-if="orderDataList.length && activeName == 'first'"
            style="margin: 10px 30px 0 0;float: right;">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="queryParams.pageNum"
              :page-size="queryParams.pageSize" layout="total,prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
          <!-- 申请发票 -->
          <el-dialog title="发票开具" :visible.sync="invoiceFlag" width="30%" :before-close="handleClose">
            <el-form ref="form" :model="form" label-width="200px">
              <el-form-item label="发票类型:">
                <el-radio-group v-model="form.type">
                  <el-radio label="个人"></el-radio>
                  <el-radio label="企业"></el-radio>
                  <el-radio label="事业单位"></el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="开票号码:">
                <el-input value="18532239782" size="mini" autocomplete="off" style="width: 60%;"></el-input>
              </el-form-item>
              <el-form-item label="总金额:">
                <!-- <el-input value="18532239782" size="mini" autocomplete="off" style="width: 60%;"></el-input> -->
                <span>￥180（共1张）</span>
              </el-form-item>
              <el-form-item label="抬头类型:">
                <span>个人/非企业单位</span>
              </el-form-item>
              <el-form-item label="发票抬头:">
                <p>韦一敏</p>
              </el-form-item>
              <el-form-item label="默认发票类型:">
                <el-radio label="增值税专用发票" v-if="form.type != '事业单位'"></el-radio>
                <el-tooltip :content="tipsContentT" placement="top" effect="light">
                  <div style="width: 300px;" slot="content">{{ tipsContentT }}</div>
                  <i style="margin-left: -27px; font-size: 16px;" class="el-icon-question"></i>
                </el-tooltip>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSubmit">立即创建</el-button>
                <el-button>取消</el-button>
              </el-form-item>
            </el-form>
            <!--              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
              </span> -->
          </el-dialog>

          <el-dialog title="新增地址" :visible.sync="dialogVisible" width="30%">
            <el-form ref="addressform" :model="addressform" label-width="120px">
              <el-form-item label="收件人：">
                <el-input v-model="addressform.name"></el-input>
              </el-form-item>
              <el-form-item label="选择地区：" prop="area">
                <el-cascader :options="areaSelectData" @change="handleChange" v-model="addressform.selectedOptions"
                  placeholder="请选择" />
              </el-form-item>
              <el-form-item label="详细地址：">
                <el-input v-model="addressform.address"></el-input>
              </el-form-item>
              <el-form-item label="联系电话：">
                <el-input v-model="addressform.mobile"></el-input>
              </el-form-item>
              <el-form-item label="邮政编码：">
                <el-input v-model="addressform.postcode"></el-input>
              </el-form-item>
              <el-form-item label="设为默认地址：">
                <el-switch v-model="addressform.default"></el-switch>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取消</el-button>
              <el-button type="primary" @click="onSubmitAddress('addressform')">提交</el-button>
              <div style="height: 30px;"></div>
            </span>
          </el-dialog>
          <el-dialog title="新增邮箱" :visible.sync="emaildialogVisible" width="30%">
            <el-form ref="emailform" :model="emailform" label-width="120px">
              <el-form-item label="邮箱：">
                <el-input v-model="emailform.email"></el-input>
              </el-form-item>
              <el-form-item label="设为默认邮箱：">
                <el-switch v-model="emailform.defaultEmail"></el-switch>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="emaildialogVisible = false">取消</el-button>
              <el-button type="primary" @click="onSubmitEmail('emailform')">提交</el-button>
              <div style="height: 30px;"></div>
            </span>
          </el-dialog>
        </div>
      </div>
    </y-shelf>
  </div>
</template>
<script>
import YShelf from '/components/YShelf'
import ServTag from '/components/ServTag'
import YButton from '/components/YButton'
import { regionData, CodeToText, TextToCode } from "element-china-area-data";
export default {
  data() {
    return {
      activeName: 'first',
      dialogVisible: false,
      emaildialogVisible: false,
      areaSelectData: regionData,
      form: {
        type: '个人',
        header: '个人',
        invoiceType: '增值税普通发票',
        code: '',
        bank: '',
        account: '',
        address: '',
        mobile: ''
      },
      addressform: {
        name: '',
        selectedOptions: '',
        address: '',
        mobile: '',
        postcode: '',
        default: false
      },
      emailform: {
        email: '',
        defaultEmail: false
      },
      tableData: [{
        name: '张三',
        mobile: '13366666666',
        address: '山东省日照市东港区富阳路198号',
        postcode: '278000'
      }],
      emailData: [],
      tipsContent: '增值税普通发票开给小规模纳税人或者开票资料不齐全的购买人，购买人取得后不可以进行进项税额抵扣。若您还有疑问，建议联系贵司财务确认后再提交开票需求。',
      tipsContentT: '增值税专用发票开给一般纳税人，申请时需要提供公司名称、税号、地址电话、开户行名称及账号，一般纳税人批复，购买人取得后可以进行进项税额抵扣。增值税专用发票只能开具纸质发票。若您还有疑问，建议联系贵司财务确认后再提交开票需求。',
      orderDataList: [],
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 8,
        servOrderNo: '',
        demPatient: '',
        dateTime: null,
        servCataId: [],
        orderStatus: '99',
        orderRushFlag: '',
        delFlag: '0'
      },
      selectIds: [],//选中的服务单集合
      invoiceFlag: false,//开局发票的dialog状态
    };
  },
  methods: {
    // 获取服务单
    loadDataList() {
      this.$api.get({
        url: '/biz/orderServ/dem/list',
        data: this.queryParams
      }).then(res => {
        this.orderDataList = res.rows
        this.total = res.total
      })
    },
    // 选中订单
    handleSelectionChange(selection) {
      this.selectIds = selection.map(item => item.servOrderId);
    },
    // 翻页
    handleCurrentChange(val) {
      this.queryParams.pageNum = val
      this.loadDataList()
    },
    // 搜索
    querySearch() {
      this.loadDataList();
    },
    // 开据发票的dialog
    handleInvoiceIssuance() {
      this.invoiceFlag = true
    },
    // 关闭dilaog
    handleClose() {
      this.invoiceFlag = false
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    onSubmit(formName) {
      this.$notify({
        title: '信息提示',
        message: '该模块目前正在维护中，如有需求请联系400-833-3316'
      });
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let formData = new FormData();
          for (var key in this.form) {
            formData.append(key, that.form[key]);
          }
          // that.formData = formData;
          // this.addForm();
        } else {
          return false;
        }
      });
    },
    onSubmitAddress(formName) {
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let formData = new FormData();
          for (var key in this.addressform) {
            formData.append(key, that.addressform[key]);
          }
          // that.formData = formData;
          // this.addForm();
        } else {
          return false;
        }
      });
    },
    onSubmitEmail(formName) {
      this.$notify({
        title: '信息提示',
        message: '该模块目前正在维护中，如有需求请联系400-833-3316'
      });
    },
    addForm() {
      var data = {
        nickName: this.formData.get('factoryName'),
        contact: this.formData.get('name'),
        // mobile: this.user ? this.user.mobile : '',
        mobile: this.formData.get('mobile'),
        email: '',
        cert: this.certList.join(','),
        desSoftType: this.formData.get('service')
      }
      this.$api.post({
        url: '/user/dem-auth',
        data: {
          nickName: this.formData.get('factoryName'),
          contact: this.formData.get('name'),
          mobile: this.formData.get('mobile'),
          mail: '',
          cert: this.certList.join(','),
          demServType: this.formData.get('service'),
          location: this.formData.get('location')
        }
      }).then(res => {
        if (res.code == 200) {
          this.$yxz.msg('申请成功，请等待审核结果', 'success')
          this.$router.push({
            path: "/"
          });
        } else {
          this.$yxz.msg(res.msg);
        }
      })
    },
    handleChange(value) {
      if (value) {
        var provinceCode = CodeToText[value[0]];//code转为省
        var cityCode = CodeToText[value[1]];//市
        var orgion = CodeToText[value[2]];//区
        var province = provinceCode;
        var city = cityCode;
        var area = orgion;
        this.form.selectedOptions = provinceCode + cityCode + orgion;
      }
    },
    handleEdit(index, row) {
      this.addressform.name = row.name
      this.addressform.mobile = row.mobile
      this.addressform.address = row.address
      this.addressform.postcode = row.postcode
      this.addressform.default = row.default
      this.dialogVisible = true
    },
    handleDelete(index, row) {
      this.tableData.splice(index, 1)
    }
  },
  created() {
    this.loadDataList()
  },
  components: {
    YShelf,
    ServTag,
    YButton,
  }
}
</script>
<style lang="scss" scoped>
.deposit-main {
  margin: 10px 50px 100px 20px;
  position: relative;
}

.select-time {
  position: absolute;
  top: 0px;
  right: 50px;
}

.tipnull {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  font-size: 20px;
  color: #d8d8d8;
  ;
}
</style>



// WEBPACK FOOTER //
// invoice.vue?34acb7e7